<template>
  <div>
    <Nuevo
      :dialog="dialog"
      @dialog="dialog = $event"
      :Item="itemSelected"
      v-if="dialog"
    />

    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header Principal estilo Inspección / Cliente -->
      <v-toolbar height="58" color="secondary" dark flat class="px-3">
        <div class="d-flex align-center">
          <v-icon left>mdi-shield-lock-outline</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Titulo || "Matriz de Permisos" }}
          </span>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary"
              >mdi-view-grid-outline</v-icon
            >
            {{ filteredMenuData ? filteredMenuData.length : 0 }} Módulos
          </v-chip>
          <v-chip
            v-if="selectedRoleName"
            small
            color="indigo lighten-4"
            text-color="indigo darken-4"
            class="font-weight-bold ml-2 px-3 elevation-1 d-none d-sm-inline-flex"
            style="font-size: 0.9rem; height: 32px"
          >
            <v-icon left size="16" color="indigo darken-3"
              >mdi-shield-account</v-icon
            >
            {{ selectedRoleName }}
          </v-chip>
        </div>

        <v-spacer></v-spacer>

        <!-- Botón Expandir / Contraer Todo -->
        <v-btn
          text
          small
          dark
          class="mr-2 text-none font-weight-medium rounded-lg expand-all-btn"
          @click="toggleAllSubMenus()"
        >
          <v-icon left small>{{
            allExpanded ? "mdi-collapse-all" : "mdi-expand-all"
          }}</v-icon>
          {{ allExpanded ? "Contraer todo" : "Expandir todo" }}
        </v-btn>

        <!-- Botón de Ayuda -->
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-1 btn-circle-tooltip"
              icon
              dark
              target="_blank"
              :href="global.helpdesk_url + 'permisos'"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="25" color="amber lighten-2"
                >mdi-help-circle-outline</v-icon
              >
            </v-btn>
          </template>
          <span>¿Necesitas ayuda?</span>
        </v-tooltip>
      </v-toolbar>

      <!-- Barra de Filtro Rápido y Acciones -->
      <div class="pa-4 pb-2">
        <v-row dense class="align-center mb-1">
          <!-- Búsqueda / Filtro de Módulos -->
          <v-col cols="12" md="7">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              label="Filtrar módulos"
              placeholder="Buscar módulo o submenú por nombre..."
              class="rounded-lg"
            ></v-text-field>
          </v-col>

          <!-- Botones de Acción -->
          <v-col
            cols="12"
            md="5"
            class="d-flex align-center justify-end flex-wrap gap-2"
          >
            <!-- Descargar Excel -->
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg mr-2"
              @click="DescargarExcel()"
            >
              <v-icon left size="18">mdi-file-excel</v-icon>
              Descargar Tabla
            </v-btn>

            <!-- Botón Nuevo Item -->
            <v-btn
              v-if="
                global._autorizacion_usuario(Permisos, $route.meta.id, ['2'])
              "
              color="primary"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nuevo
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- Tabla de Matriz de Permisos -->
      <div class="table-responsive-wrapper">
        <v-data-table
          height="540"
          :items="filteredMenuData"
          item-value="menu"
          :headers="actionHeadersTable"
          fixed-header
          dense
          hide-default-footer
          :disable-pagination="true"
          class="modern-table elevation-0"
          :loading="Loading"
          loading-text="Cargando permisos... Por favor, espere"
          no-data-text="No se encontraron módulos disponibles"
        >
          <template v-slot:item="{ item }">
            <!-- Fila Nivel 1 (Módulo Principal) -->
            <tr
              :class="{
                'parent-row-highlight':
                  item.menu_submenu && item.menu_submenu.length > 0,
                'open-parent': item.isOpen,
              }"
            >
              <template
                v-if="item.menu_submenu && item.menu_submenu.length > 0"
              >
                <td class="module-title-cell font-weight-bold">
                  <div class="d-flex align-center justify-space-between w-100">
                    <div class="d-flex align-center">
                      <v-icon small color="primary" class="mr-2">{{
                        item.icon || "mdi-folder"
                      }}</v-icon>
                      <span
                        class="text-subtitle-2 font-weight-bold text--primary"
                        >{{ item.menu }}</span
                      >
                      <v-chip
                        x-small
                        color="grey lighten-3"
                        class="ml-2 font-weight-bold"
                        text-color="grey darken-3"
                      >
                        {{ item.menu_submenu.length }}
                      </v-chip>
                    </div>
                    <v-btn
                      icon
                      x-small
                      @click="toggleSubMenu(item)"
                      class="toggle-btn ml-1"
                      title="Expandir/Contraer"
                    >
                      <v-icon size="20" color="grey darken-2">
                        {{
                          item.isOpen ? "mdi-chevron-up" : "mdi-chevron-down"
                        }}
                      </v-icon>
                    </v-btn>
                  </div>
                </td>
                <td class="text-center">
                  <v-chip
                    x-small
                    :color="
                      item.id_cliente == '0'
                        ? 'blue-grey lighten-5'
                        : 'amber lighten-5'
                    "
                    :text-color="
                      item.id_cliente == '0'
                        ? 'blue-grey darken-3'
                        : 'amber darken-4'
                    "
                    class="font-weight-bold border-chip"
                  >
                    {{ item.id_cliente == "0" ? "Principal" : "Secundario" }}
                  </v-chip>
                </td>
                <td
                  v-for="action in actionHeaders"
                  :key="action.id"
                  class="text-center"
                >
                  <span class="text--disabled text-caption font-weight-light"
                    >—</span
                  >
                </td>
              </template>

              <template v-else>
                <td class="module-title-cell">
                  <div class="d-flex align-center">
                    <v-icon small color="secondary" class="mr-2">{{
                      item.icon || "mdi-file-document-outline"
                    }}</v-icon>
                    <span class="font-weight-medium text--primary">{{
                      item.menu
                    }}</span>
                  </div>
                </td>
                <td class="text-center">
                  <v-chip
                    x-small
                    :color="
                      item.id_cliente == '0'
                        ? 'blue-grey lighten-5'
                        : 'amber lighten-5'
                    "
                    :text-color="
                      item.id_cliente == '0'
                        ? 'blue-grey darken-3'
                        : 'amber darken-4'
                    "
                    class="font-weight-bold border-chip"
                  >
                    {{ item.id_cliente == "0" ? "Principal" : "Secundario" }}
                  </v-chip>
                </td>
                <td
                  v-for="action in actionHeaders"
                  :key="action.id"
                  class="text-center checkbox-td"
                >
                  <template v-if="hasAction(item.acciones, action.id)">
                    <div class="d-flex align-center justify-center">
                      <v-simple-checkbox
                        :value="isChecked(action.id, item.id)"
                        @click="
                          canEditPermisos
                            ? updatepermisoxrol(item.id, action.id)
                            : ''
                        "
                        color="primary"
                        :readonly="!canEditPermisos"
                        class="permission-checkbox"
                      ></v-simple-checkbox>
                    </div>
                  </template>
                  <template v-else>
                    <span class="text--disabled text-caption font-weight-light"
                      >—</span
                    >
                  </template>
                </td>
              </template>
            </tr>

            <!-- Fila Nivel 2 (Submenú) -->
            <template v-if="item.isOpen" v-for="subItem in item.menu_submenu">
              <tr :key="subItem.id" class="subitem-row">
                <template
                  v-if="subItem.menu_submenu && subItem.menu_submenu.length > 0"
                >
                  <td class="module-title-cell subitem-cell font-weight-medium">
                    <div
                      class="d-flex align-center justify-space-between w-100 pl-5"
                    >
                      <div class="d-flex align-center">
                        <v-icon x-small color="indigo" class="mr-2"
                          >mdi-subdirectory-arrow-right</v-icon
                        >
                        <span class="text--primary">{{ subItem.menu }}</span>
                        <v-chip
                          x-small
                          color="grey lighten-3"
                          class="ml-2 font-weight-bold"
                          text-color="grey darken-3"
                        >
                          {{ subItem.menu_submenu.length }}
                        </v-chip>
                      </div>
                      <v-btn
                        icon
                        x-small
                        @click="toggleSubMenu(subItem)"
                        class="toggle-btn ml-1"
                        title="Expandir/Contraer"
                      >
                        <v-icon size="18" color="grey darken-2">
                          {{
                            subItem.isOpen
                              ? "mdi-chevron-up"
                              : "mdi-chevron-down"
                          }}
                        </v-icon>
                      </v-btn>
                    </div>
                  </td>
                  <td class="text-center">
                    <v-chip
                      x-small
                      :color="
                        subItem.id_cliente == '0'
                          ? 'blue-grey lighten-5'
                          : 'amber lighten-5'
                      "
                      :text-color="
                        subItem.id_cliente == '0'
                          ? 'blue-grey darken-3'
                          : 'amber darken-4'
                      "
                      class="font-weight-bold border-chip"
                    >
                      {{
                        subItem.id_cliente == "0" ? "Principal" : "Secundario"
                      }}
                    </v-chip>
                  </td>
                  <td
                    v-for="action in actionHeaders"
                    :key="action.id"
                    class="text-center"
                  >
                    <span class="text--disabled text-caption font-weight-light"
                      >—</span
                    >
                  </td>
                </template>
                <template v-else>
                  <td class="module-title-cell subitem-cell">
                    <div class="d-flex align-center pl-5">
                      <v-icon x-small color="indigo lighten-2" class="mr-2"
                        >mdi-subdirectory-arrow-right</v-icon
                      >
                      <span class="text--primary">{{ subItem.menu }}</span>
                    </div>
                  </td>
                  <td class="text-center">
                    <v-chip
                      x-small
                      :color="
                        subItem.id_cliente == '0'
                          ? 'blue-grey lighten-5'
                          : 'amber lighten-5'
                      "
                      :text-color="
                        subItem.id_cliente == '0'
                          ? 'blue-grey darken-3'
                          : 'amber darken-4'
                      "
                      class="font-weight-bold border-chip"
                    >
                      {{
                        subItem.id_cliente == "0" ? "Principal" : "Secundario"
                      }}
                    </v-chip>
                  </td>
                  <td
                    v-for="action in actionHeaders"
                    :key="action.id"
                    class="text-center checkbox-td"
                  >
                    <template v-if="hasAction(subItem.acciones, action.id)">
                      <div class="d-flex align-center justify-center">
                        <v-simple-checkbox
                          :value="isChecked(action.id, subItem.id)"
                          @click="
                            canEditPermisos
                              ? updatepermisoxrol(subItem.id, action.id)
                              : ''
                          "
                          color="primary"
                          :readonly="!canEditPermisos"
                          class="permission-checkbox"
                        ></v-simple-checkbox>
                      </div>
                    </template>
                    <template v-else>
                      <span
                        class="text--disabled text-caption font-weight-light"
                        >—</span
                      >
                    </template>
                  </td>
                </template>
              </tr>

              <!-- Fila Nivel 3 (Sub-submenú) -->
              <template
                v-if="subItem.isOpen"
                v-for="subsubItem in subItem.menu_submenu"
              >
                <tr :key="subsubItem.id" class="subsubitem-row">
                  <template
                    v-if="
                      subsubItem.menu_submenu &&
                      subsubItem.menu_submenu.length > 0
                    "
                  >
                    <td
                      class="module-title-cell subsubitem-cell font-weight-medium"
                    >
                      <div
                        class="d-flex align-center justify-space-between w-100 pl-10"
                      >
                        <div class="d-flex align-center">
                          <v-icon x-small color="grey" class="mr-2"
                            >mdi-minus</v-icon
                          >
                          <span>{{ subsubItem.menu }}</span>
                        </div>
                        <v-btn
                          icon
                          x-small
                          @click="toggleSubMenu(subsubItem)"
                          class="toggle-btn ml-1"
                        >
                          <v-icon size="18" color="grey darken-2">
                            {{
                              subsubItem.isOpen
                                ? "mdi-chevron-up"
                                : "mdi-chevron-down"
                            }}
                          </v-icon>
                        </v-btn>
                      </div>
                    </td>
                    <td class="text-center">
                      <v-chip
                        x-small
                        :color="
                          subsubItem.id_cliente == '0'
                            ? 'blue-grey lighten-5'
                            : 'amber lighten-5'
                        "
                        :text-color="
                          subsubItem.id_cliente == '0'
                            ? 'blue-grey darken-3'
                            : 'amber darken-4'
                        "
                        class="font-weight-bold border-chip"
                      >
                        {{
                          subsubItem.id_cliente == "0"
                            ? "Principal"
                            : "Secundario"
                        }}
                      </v-chip>
                    </td>
                    <td
                      v-for="action in actionHeaders"
                      :key="action.id"
                      class="text-center"
                    >
                      <span
                        class="text--disabled text-caption font-weight-light"
                        >—</span
                      >
                    </td>
                  </template>
                  <template v-else>
                    <td class="module-title-cell subsubitem-cell">
                      <div class="d-flex align-center pl-10">
                        <v-icon x-small color="grey" class="mr-2"
                          >mdi-circle-small</v-icon
                        >
                        <span class="text--secondary">{{
                          subsubItem.menu
                        }}</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <v-chip
                        x-small
                        :color="
                          subsubItem.id_cliente == '0'
                            ? 'blue-grey lighten-5'
                            : 'amber lighten-5'
                        "
                        :text-color="
                          subsubItem.id_cliente == '0'
                            ? 'blue-grey darken-3'
                            : 'amber darken-4'
                        "
                        class="font-weight-bold border-chip"
                      >
                        {{
                          subsubItem.id_cliente == "0"
                            ? "Principal"
                            : "Secundario"
                        }}
                      </v-chip>
                    </td>
                    <td
                      v-for="action in actionHeaders"
                      :key="action.id"
                      class="text-center checkbox-td"
                    >
                      <template
                        v-if="hasAction(subsubItem.acciones, action.id)"
                      >
                        <div class="d-flex align-center justify-center">
                          <v-simple-checkbox
                            :value="isChecked(action.id, subsubItem.id)"
                            @click="
                              canEditPermisos
                                ? updatepermisoxrol(subsubItem.id, action.id)
                                : ''
                            "
                            color="primary"
                            :readonly="!canEditPermisos"
                            class="permission-checkbox"
                          ></v-simple-checkbox>
                        </div>
                      </template>
                      <template v-else>
                        <span
                          class="text--disabled text-caption font-weight-light"
                          >—</span
                        >
                      </template>
                    </td>
                  </template>
                </tr>
              </template>
            </template>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Nuevo from "./nuevo.vue";
import exportFromJSON from "export-from-json";
import global from "@/global";

export default {
  props: [
    "Titulo",
    "Items",
    "Excel",
    "Crear",
    "Loading",
    "menuData",
    "permisosxroles",
    "headers",
    "subHeaders",
    "subSubHeaders",
    "actionHeaders",
    "actionHeadersTable",
    "filtroRoles",
    "selected",
    "selectedRoleName",
  ],
  components: {
    Nuevo,
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    canEditPermisos() {
      return global._autorizacion_usuario(this.Permisos, this.$route.meta.id, [
        "3",
      ]);
    },
    filteredMenuData() {
      if (!this.menuData) return [];
      if (!this.search || !this.search.trim()) return this.menuData;
      const term = this.search.toLowerCase().trim();

      return this.menuData.filter((item) => {
        const matchParent = item.menu && item.menu.toLowerCase().includes(term);
        const matchSub =
          item.menu_submenu &&
          item.menu_submenu.some((sub) => {
            const matchS = sub.menu && sub.menu.toLowerCase().includes(term);
            const matchSS =
              sub.menu_submenu &&
              sub.menu_submenu.some(
                (ss) => ss.menu && ss.menu.toLowerCase().includes(term),
              );
            return matchS || matchSS;
          });
        return matchParent || matchSub;
      });
    },
  },
  data() {
    return {
      dialog: false,
      itemSelected: {},
      global: global,
      search: "",
      allExpanded: false,
    };
  },
  methods: {
    ...mapActions("roles", ["eliminarRoles", "asignarPermisos"]),

    toggleSubMenu(item) {
      this.$set(item, "isOpen", !item.isOpen);
    },

    toggleAllSubMenus() {
      this.allExpanded = !this.allExpanded;
      const setOpen = (items, state) => {
        if (!items) return;
        items.forEach((item) => {
          this.$set(item, "isOpen", state);
          if (item.menu_submenu && item.menu_submenu.length > 0) {
            setOpen(item.menu_submenu, state);
          }
        });
      };
      setOpen(this.menuData, this.allExpanded);
    },

    hasAction(acciones, actionId) {
      return acciones && acciones.includes(actionId);
    },

    isChecked(actionId, idmenu) {
      let result = false;
      if (!this.permisosxroles) return false;
      Object.keys(this.permisosxroles).forEach((key) => {
        const element = this.permisosxroles[key];
        if (
          parseInt(element.menu) === parseInt(idmenu) &&
          parseInt(element.accion) === parseInt(actionId)
        ) {
          result = true;
        }
      });
      return result;
    },

    updatepermisoxrol(idmenu, idaccion) {
      const data = {
        name: this.selected,
        name_permiso: idmenu + "." + idaccion,
      };
      this.asignarPermisos(data).then(() => {
        if (this.filtroRoles) {
          this.filtroRoles();
        }
      });
    },

    eliminar(item) {
      this.$alertify
        .confirm(
          "¿Desea eliminar este item ID: " + item.id + "?",
          () => {
            this.eliminarRoles(item).then(() => {
              this.$alertify.success(
                "Item ID: " + item.id + " eliminado correctamente",
              );
            });
          },
          () => this.$alertify.error("Se canceló la acción"),
        )
        .setHeader('<h3 class="alertTitle">Aviso</h3>');
    },

    nuevoItem() {
      this.itemSelected = {
        id: 0,
        nombre: "",
        edad: 0,
        profesion: "",
      };
      this.dialog = true;
    },

    editarItem(item) {
      this.itemSelected = { ...item };
      this.dialog = true;
    },

    DescargarExcel() {
      const data = this.menuData || this.Items;
      const nombreArchivo = "permisos_rol_" + (this.selected || "export");
      const exportType = exportFromJSON.types.xls;
      exportFromJSON({ data, nombreArchivo, exportType });
    },
  },
};
</script>

<style scoped>
.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-size: 0.82rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px;
  white-space: nowrap;
  height: 44px !important;
  border-bottom: none !important;
  vertical-align: middle;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th .v-icon {
  color: #ffffff !important;
}

.modern-table ::v-deep thead tr.v-data-table__progress th {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 6px 12px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.parent-row-highlight {
  background-color: #f8fafc !important;
  border-bottom: 1.5px solid #e2e8f0 !important;
}

.parent-row-highlight:hover {
  background-color: #f1f5f9 !important;
}

.subitem-row {
  background-color: #ffffff !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.subitem-row:hover {
  background-color: #f8fafc !important;
}

.subsubitem-row {
  background-color: #fafbfc !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.subsubitem-row:hover {
  background-color: #f1f5f9 !important;
}

.module-title-cell {
  min-width: 260px;
}

.checkbox-td {
  width: 100px;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
}

.checkbox-td:hover {
  background-color: rgba(0, 123, 255, 0.04);
}

.permission-checkbox {
  cursor: pointer;
  transition: transform 0.15s ease-in-out;
}

.permission-checkbox:hover {
  transform: scale(1.18);
}

.toggle-btn {
  transition: background-color 0.2s ease;
}

.toggle-btn:hover {
  background-color: rgba(0, 0, 0, 0.06) !important;
}

.expand-all-btn {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
}

.expand-all-btn:hover {
  background: rgba(255, 255, 255, 0.25) !important;
}

.border-chip {
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
